import React from 'react';

const isProd = process.env.NODE_ENV === 'production';

type DocsVisibilityState = {
  showAllDocs: boolean;
  setShowAllDocs: (next: boolean) => void;
};

const DocsVisibilityContext = React.createContext<DocsVisibilityState | null>(
  null,
);

export const DocsVisibilityProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [showAllDocs, setShowAllDocs] = React.useState(!isProd);

  const value = React.useMemo(
    () => ({
      showAllDocs,
      setShowAllDocs,
    }),
    [showAllDocs],
  );

  return (
    <DocsVisibilityContext value={value}>{children}</DocsVisibilityContext>
  );
};

export const useDocsVisibility = () => {
  const context = React.use(DocsVisibilityContext);
  if (!context) {
    throw new Error('DocsVisibilityProvider is missing');
  }
  return context;
};

export const isProductionDocsView = isProd;
